import type { Locale } from "@/lib/i18n";
import { pl, type CBlogTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cBlogTranslations: Record<Locale, CBlogTranslations> = {
  pl,
  en,
  de,
};

export type { CBlogTranslations };
